/** Кука «просмотра» поп-апа сбора отзывов (отдельно от auth). */
export const REVIEW_POPUP_VIEWED_COOKIE = 'tripster_review_popup_viewed';

/** TTL куки — 180 дней (в духе окна неоценённых заказов). */
export const REVIEW_POPUP_VIEWED_MAX_AGE_SEC = 180 * 24 * 60 * 60;

export const REVIEW_MIN_DELAY_MS = 30 * 60 * 1000;
export const REVIEW_MAX_WINDOW_MS = 180 * 24 * 60 * 60 * 1000;
